// extracted by mini-css-extract-plugin
module.exports = {"page":"Intro_page__1L74o Layout_page__3AEwV","hero":"Intro_hero__2ooq0","startBtn":"Intro_startBtn__3vE0Y","heroTitle":"Intro_heroTitle__2Rpj-","heroText":"Intro_heroText__370jN"};